
import React from 'react';

import { Link } from 'react-router-dom';

function EligibilityRequirements() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-8 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Eligibility Requirements</h1>

        <div className="bg-[#F9FAFB] border-l-4 border-gray-400 p-4 text-sm text-[#64748B] mb-8">
           <strong>Notice:</strong> The AI Accountability Standards Council is an independent standards body. The AASC Accountability Declaration does not confer legal status or regulatory approval.
        </div>

        <div className="text-sm text-gray-800 leading-relaxed space-y-8">
          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Eligible Applicants</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Registered Legal Entity:</strong> The applicant must be a formally registered corporation, LLC, or equivalent legal entity in its jurisdiction of operation.</li>
              <li><strong>AI Use:</strong> The organization must actively use AI tools internally or in client-facing work.</li>
              <li><strong>Quantifiable Workflows:</strong> The organization must possess active, measurable workflows capable of generating audit trails.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Eligibility Review</h2>
            <p>
              The Council reviews eligibility during the initial phase of the application process.
            </p>
          </section>

          <div className="pt-8 border-t border-gray-200 mt-8">
            <Link to="/apply" className="text-[#2F80ED] hover:underline">Start Your Declaration &rarr;</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default EligibilityRequirements;
